import script from "./SidebarNavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarNavItem.vue?vue&type=script&setup=true&lang=js"

import "./SidebarNavItem.vue?vue&type=style&index=0&id=d856c3f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d856c3f0"]])

export default __exports__